export default {

	// Headers
	HEADERS: {
		// key: process.env.KEY_API,
		key: "client03-TSbs94s3q5H9PP2yNPBr",
		version: "1.5",
		device: "3",
		"content-type": "application/json",
	},
	HEADERS_WALLET: {
		key: "client03-TSbs94s3q5H9PP2yNPBr",
		version: "1.5",
		device: "3",
	},
	HEADERS_V2: {
		key: "client03-TSbs94s3q5H9PP2yNPBr",
		version: "1.5",
		device: "3",
	},
	// Api timeout
	REQUEST_TIMEOUT: 7000,

};
